import React from 'react'
import { Modal, FormControl, Button } from 'react-bootstrap'
import DatePicker from 'react-16-bootstrap-date-picker'
import { Typeahead } from 'react-bootstrap-typeahead'

const NewDeliverable = (props) => {
  const { show, name, notes, dueDate, status, analysts, uniqueUserOptions } = props

  return (
    <Modal show={show} onHide={() => null}>
      <Modal.Header>
        <Modal.Title>New Deliverable</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="required">
          Required fields marked with *
        </p>
        <div>
          <h5>
            <span className="required">*</span>
            Deliverable:
          </h5>
          <FormControl
            name="name"
            value={name}
            type="text"
            onChange={props.handleChange}
          />
        </div>
        <div>
          <h5>Notes:</h5>
          <FormControl
            name="notes"
            value={notes}
            type="text"
            onChange={props.handleChange}
          />
        </div>
        <div>
          <h5>
            <span className="required">*</span>
            Due Date:
          </h5>
          <DatePicker
            name="dueDate"
            value={dueDate}
            dateFormat="MM-DD-YYYY"
            weekStartsOn={1}
            showTodayButton={true}
            showClearButton={false}
            onChange={(date) => props.handleChange({target: { name: 'dueDate', value: date }})}
            />
        </div>
        <div>
          <h5>
            <span className="required">*</span>
            Status:
          </h5>
          <FormControl
            name="status"
            value={status}
            componentClass="select"
            placeholder="select"
            onChange={props.handleChange}
          >
            <option value="On Going">On Going</option>
            <option value="Not Started">Not Started</option>
            <option value="Completed">Completed</option>
          </FormControl>
        </div>
        <div>
          <h5>
            Assigned to:
          </h5>
          <Typeahead
            id={'New_Deliverable_Analysts'}
            multiple
            labelKey={(user) => `${user.first_name} ${user.last_name}`}
            renderMenuItemChildren={props._renderMenuItemChildren}
            options={uniqueUserOptions}
            selected={analysts}
            onChange={(value) => props.handleChange({target: {name: 'analysts', value}})}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.handleCancel}>
          Cancel
        </Button>
        <Button bsStyle="primary" onClick={props.handleSubmit}>
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default NewDeliverable



// WEBPACK FOOTER //
// ./src/reuseable-components/deliverables/NewDeliverable.js